var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    fill: "white",
    stroke: "#DAD4CE",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8346 10.0683C20.092 9.81102 20.5081 9.81102 20.7627 10.0683L21.9289 11.2346C22.1862 11.4919 22.1862 11.908 21.9289 12.1626L20.4314 13.6656L18.3344 11.5686L19.8346 10.0683ZM17.7157 12.1873L19.8127 14.2843L13.3684 20.7258C13.1604 20.9339 12.9058 21.0845 12.6238 21.1666L10.0833 21.9167L10.8307 19.3762C10.9128 19.0942 11.0661 18.8396 11.2714 18.6316L17.7157 12.1873ZM21.3841 9.44965C20.7846 8.85012 19.8155 8.85012 19.2159 9.44965L10.6527 18.0101C10.3406 18.3222 10.1134 18.7055 9.99022 19.1271L9.01837 22.4396C8.97183 22.5929 9.01564 22.7599 9.12788 22.8721C9.24012 22.9844 9.40711 23.0282 9.56042 22.9816L12.8729 22.007C13.2945 21.8838 13.6778 21.6539 13.9899 21.3445L22.5503 12.7841C23.1499 12.1845 23.1499 11.2154 22.5503 10.6159L21.3841 9.44965Z",
    fill: "#202020",
    stroke: "#202020",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileEditIcon);
export default __webpack_public_path__ + "static/media/profile_edit_icon.23f3197b7973d936de7433e2c5fda326.svg";
export { ForwardRef as ReactComponent };